export const BLEED_WIDTH: number = 20;
export const MAX_WIDTH: number = 1600;
export const MAX_HEIGHT: number = 800;
export const MM_TO_INCH = 0.0393701;
export const ALL = "all";
export const BROWSER_MAX_H_W: number = 32767;
export const BROWSER_MAX_AREA: number = 268435456;
